import $ from "jquery"
import useUser from "../../../../core/hooks/use-user";
import Datatable from "../../../../core/ui/components/Datatable";
import { toast } from "../../../../core/helpers/message-helper";
import { API_URL } from "../../../../core/config/env";
import ContentWrapper from "../../../../core/ui/components/Layout/ContentWrapper";
import { useState } from "react";
import useModal from "../../../../core/hooks/use-modal";
import FormSoftware from "../components/form-software";
import { useEffect } from "react";
import ListarInvolucrados from "../components/listar-involucrados";
import FormInvolucrados from "../components/form-involucrados";
import ListarAnexos from "../components/listar-anexos";
import ListarRequerimientos from "../components/listar-requerimientos";
import ListarRestricciones from "../components/listar-restricciones";
import FormRestricciones from "../components/form-restricciones";
import FormRequerimientos from "../components/form-requerimientos";
import FormAnexos from "../components/form-anexos";

const Software = () => {
    const { getAccessToken } = useUser();
    const token = getAccessToken();
    const [dtInstance, onDtInstance] = useState();

    const modalSoftware = useModal({
        title: "Crear requerimiento de Software",
        data: { Software: {} },
    });

    const getDtInstance = (dt) => onDtInstance(dt);

    const onSave = () => {
        dtInstance.ajax.reload();
    };

    function obtenerDatosFilaTabla(btnClick) {
        var row = $(btnClick).closest("tr");

        return $("#tableSoftware").DataTable().row(row).data();
    }

    const modalListarInvolucrados = useModal({
        title: "Lista de personas involucradas en el desarrollo",
        data: { involucrados: {} },
    });

    const modalListarRequerimientos = useModal({
        title: "Lista de requerimientos del desarrollo",
        data: { requerimientos: {} },
    });

    const modalListarRestricciones = useModal({
        title: "Lista de restricciones del desarrollo",
        data: { restricciones: {} },
    });

    const modalListarAnexos = useModal({
        title: "Lista de anexos del desarrollo",
        data: { anexos: {} },
    });

    const modalCrearInvolucrados = useModal({
        title: "Crear requerimiento de Software",
        data: { involucrados: {} },
    });

    const modalCrearRequerimientos = useModal({
        title: "Crear requerimientos de Software",
        data: { requerimientos: {} },
    });

    const modalCrearRestricciones = useModal({
        title: "Crear restricciones de Software",
        data: { restricciones: {} },
    });

    const modalCrearAnexos = useModal({
        title: "Crear anexos de Software",
        data: { anexos: {} },
    });

    useEffect(() => {
        $("#tableSoftware tbody").on("click", ".involucrados", function () {
            const involucrados = obtenerDatosFilaTabla(this);
            modalListarInvolucrados.set({
                show: true,
                title: "Lista de personas involucradas en el desarrollo",
                data: { involucrados },
            });
        });

        $("#tableSoftware tbody").on("click", ".requerimientos", function () {
            const requerimientos = obtenerDatosFilaTabla(this);
            modalListarRequerimientos.set({
                show: true,
                title: "Lista de requerimientos del desarrollo",
                data: { requerimientos },
            });
        });

        $("#tableSoftware tbody").on("click", ".restricciones", function () {
            const restricciones = obtenerDatosFilaTabla(this);
            modalListarRestricciones.set({
                show: true,
                title: "Lista de restricciones del desarrollo",
                data: { restricciones },
            });
        });

        $("#tableSoftware tbody").on("click", ".anexos", function () {
            const anexos = obtenerDatosFilaTabla(this);
            modalListarAnexos.set({
                show: true,
                title: "Lista de anexos del desarrollo",
                data: { anexos },
            });
        });
    }, []);

    let tableButtons = [];

    tableButtons.push({
        titleAttr: "Crear requerimiento de Software",
        text: '<i class="fas fa-plus"></i>',
        action: function () {
            modalSoftware.open({
                title: "Crear requerimiento de Software",
                data: { software: {} },
            });
        },
        className: "btn btn-sm btn-secondary",
    });

    tableButtons.push({
        titleAttr: "Crear involucrados del proyecto",
        text: '<i class="fas fa-plus fa-sm mr-1"></i><i class="fas fa-users fa-lg"></i>',
        action: function () {
            modalCrearInvolucrados.open({
                title: "Crear involucrados del proyecto",
                data: { involucrados: {} },
            });
        },
        className: "btn btn-sm btn-primary",
    });

    tableButtons.push({
        titleAttr: "Crear requerimientos del proyecto",
        text: '<i class="fas fa-plus fa-sm mr-1"></i><i class="fas fa-th-list fa-lg"></i>',
        action: function () {
            modalCrearRequerimientos.open({
                title: "Crear requerimientos del proyecto",
                data: { involucrados: {} },
            });
        },
        className: "btn btn-sm btn-salmon",
    });

    tableButtons.push({
        titleAttr: "Crear restricciones del proyecto",
        text: '<i class="fas fa-plus fa-sm mr-1"></i><i class="fas fa-exclamation-triangle fa-lg"></i>',
        action: function () {
            modalCrearRestricciones.open({
                title: "Crear restricciones del proyecto",
                data: { involucrados: {} },
            });
        },
        className: "btn btn-sm btn-danger",
    });

    tableButtons.push({
        titleAttr: "Crear anexos del proyecto",
        text: '<i class="fas fa-plus fa-sm mr-1"></i><i class="fas fa-file-signature fa-lg"></i>',
        action: function () {
            modalCrearAnexos.open({
                title: "Crear anexos del proyecto",
                data: { anexos: {} },
            });
        },
        className: "btn btn-sm btn-grey",
    });

    tableButtons = [
        ...tableButtons,
        {
            titleAttr: "Exportar a Excel",
            text: '<i class="fas fa-file-excel"></i>',
            extend: "excelHtml5",
            className: "btn btn-sm btn-success",
            exportOptions: {
                modifier: {
                    order: "current",
                    page: "all",
                },
            },
            filename: "requerimientos-software",
        },
        {
            titleAttr: "Imprimir",
            text: '<i class="fa fa-lg fa-print"></i>',
            extend: "print",
            className: "btn btn-sm btn-warning",
        },
    ];

    const dtOptions = {
        searchable: true,
        serverSide: false,
        dom: "Bfrtip",
        id: "tableSoftware",
        select: {
            style: "single",
        },
        buttons: tableButtons,
        ajax: {
            url: `${API_URL}/software`,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", `Bearer ${token}`);
            },
            type: "get",
            dataType: "json",
            error: () => {
                toast.error(
                    "Ha ocurrido un error al obtener el listado de requerimientos"
                );
            },
        },
        columns: [
            { data: "id" },
            {
                data: null,
                defaultContent: `
                    <button class="involucrados btn btn-primary btn-sm mr-1" title="Involucrados"><i class="fas fa-users"></i></button>
                    <button class="requerimientos btn btn-salmon btn-sm" title="Requerimientos"><i class="fas fa-th-list"></i></button>
                    <br>
                    <button class="restricciones btn btn-danger btn-sm mt-1 mr-1" title="Restricciones"><i class="fas fa-exclamation-triangle"></i></button>
                    <button class="anexos btn btn-grey btn-sm mt-1" title="Anexos"><i class="fas fa-file-signature"></i></button>`,
            },
            { data: "nombre" },
            { data: "info_solicitud" },
            { data: "proposito" },
            { data: "alcance" },
        ],
    };

    return (
        <ContentWrapper>
            <div className="content-heading">
                <div>
                    REQUERIMIENTOS / Solicitudes De Desarrollo De Software
                </div>
            </div>
            <Datatable options={dtOptions} dtInstance={getDtInstance}>
                <table className="w-100 table table-hover" id="tableSoftware">
                    <thead className="bg-dark">
                        <tr>
                            <th className="text-center text-white">Id</th>
                            <th className="text-center text-white">Acciones</th>
                            <th className="text-center text-white">Nombre</th>
                            <th className="text-center text-white">
                                Info Solicitud
                            </th>
                            <th className="text-center text-white">
                                Proposito
                            </th>
                            <th className="text-center text-white">Alcance</th>
                        </tr>
                    </thead>
                </table>
            </Datatable>
            <FormSoftware modalState={modalSoftware} onSave={onSave} />
            <ListarInvolucrados modalState={modalListarInvolucrados} />
            <FormInvolucrados
                modalState={modalCrearInvolucrados}
                onSave={onSave}
            />
            <ListarAnexos modalState={modalListarAnexos} />
            <FormAnexos
                modalState={modalCrearAnexos}
                onSave={onSave}
            />
            <ListarRequerimientos modalState={modalListarRequerimientos} />
            <FormRequerimientos
                modalState={modalCrearRequerimientos}
                onSave={onSave}
            />
            <ListarRestricciones modalState={modalListarRestricciones} />
            <FormRestricciones
                modalState={modalCrearRestricciones}
                onSave={onSave}
            />
        </ContentWrapper>
    );
};

export default Software;
